/*
 * @Description:
 * @Date: 2024-03-15 11:37:43
 */

import {
  BaseButton,
  BaseImage,
  createDialog,
  createImageViewer,
  BaseTextContent
} from 'xrk-components';
import { useFile } from '@/hooks/use-file';

/**
 * 给每一项增加textLineClamp
 * @param columns
 * @param count
 * @returns
 */
export function dealTableColumnstextLineClamp<T extends Array<any>>(
  columns: T,
  count = 999
) {
  return columns.map(i => ({
    ...i,
    textLineClamp: i.textLineClamp || count
  }));
}

export function delConfirm(callback: () => Promise<any>) {
  createDialog({
    width: 360,
    title: '提示',
    contentRender: () => (
      <BaseTextContent>
        <p style={{ textAlign: 'center' }}>是否删除</p>
      </BaseTextContent>
    ),
    confirmBtnConfig: {
      show: true,
      type: 'primary',
      content: '确定'
    },
    cancelBtnConfig: { show: true, type: 'default', content: '取消' },
    beforeConfirm: async () => {
      await callback();
    }
  });
}

export function tableColumnImgRender(
  disabled: boolean,
  isOwnPublish: boolean,
  url: string,
  changeImgUrl: (newImgUrl: string) => void,
  showDetail: () => any
) {
  return (
    <>
      {!url ? (
        isOwnPublish ? (
          <BaseButton
            type="text"
            disabled={disabled}
            click={async () => {
              if (showDetail) {
                showDetail?.();
                return;
              }
              const { chooseFile } = useFile();
              const file = await chooseFile(['.jpg', '.png', '.jpge', '.gif']);
              const url = URL.createObjectURL(file);
              changeImgUrl?.(url);
            }}
          >
            点击上传
          </BaseButton>
        ) : (
          <>-</>
        )
      ) : (
        <div
          onClick={() => {
            const ref = createImageViewer({
              previewTeleported: true,
              hideOnClickModal: true,
              previewSrcList: [url]
            });
            ref.unregisterEventListener?.();
          }}
        >
          <BaseImage
            src={url}
            style={{ maxHeight: '40px' }}
            fit="contain"
          ></BaseImage>
        </div>
      )}
    </>
  );
}
